import {useMemo} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import {isAzubi, isAusbilder, isTrainer, isAusbilderOrTrainer, isFachausbilder} from 'ag-common/tools/roles'

const currentUserRoleSelector = state => state.authentication.role
export function useCurrentUserRole() {
  const role = useSelector(currentUserRoleSelector, shallowEqual)
  return useMemo(
    () => ({
      role,
      isAzubi: isAzubi(role),
      isAusbilder: isAusbilder(role),
      isTrainer: isTrainer(role),
      isAusbilderOrTrainer: isAusbilderOrTrainer(role),
      isFachausbilder: isFachausbilder(role),
    }),
    [role],
  )
}
